import styled from '@emotion/styled';
import { Button } from 'ui_system/token_auth/elements/Button';
import { Label as defaultLabel, SubLabel } from 'ui_system/forms/FormStyles';
import Logo from 'views/anyguide/layout/logo';
import { Theme } from 'ui_system/theme';

export const Container = styled.div`
  font-size: 12px;
  margin: 0 auto;
  padding: 20px;
  @media (min-width: ${Theme.mobile.phoneWidth}px) {
    max-width: 700px;
    padding: initial;
  }
`;

export const InputContainer = styled.div`
  margin: 0 auto 0 0;
  width: 100%;
  @media (min-width: ${Theme.mobile.phoneWidth}px) {
    width: 50%;
  }
`;

export const H1 = styled.h1`
  font-size: 31px;
  text-align: center;
  font-weight: 600;
  margin-top: 84px;
`;

export const FormH1 = styled(H1)`
  margin-top: 50px;
`;

export const BareHR = styled.hr`
  margin-block-start: 0;
  margin-block-end: 0;
`;

export const SubmitButton = styled(Button)`
  width: 140px;
  height: 44px;
  font-size: 16px;
  padding: 12px 45.5px;
  background-color: ${Theme.colors.red};
  color: #ffffff;
  margin: 30px auto 100px auto;
  @media (min-width: ${Theme.mobile.phoneWidth}px) {
    margin: 30px 0px 100px 0px;
  }
`;

export const BodyText = styled.div`
  margin-top: 30px;
  font-size: 16px;
  text-align: center;
`;

export const TopSpacer = styled.div`
  margin-top: 20px;
`;

export const Label = styled(defaultLabel)`
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 5px;
`;

export const IndentedSubLabel = styled(SubLabel)`
  margin-left: 40px;
  line-height: 1.4em;
`;

export const RedLink = styled.a`
  color: ${Theme.colors.red};
`;

export const P = styled.p`
  margin-top: 15px;
`;

export const SwornText = styled.div`
  font-size: 14px;
`;
